<div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div class="filter-section w-full">
    <app-coach-groups-list-filter></app-coach-groups-list-filter>
  </div>
  <div
    class="table-section"
  >
    <mat-expansion-panel
      class="mat-elevation-z0 expansion-panel w-full"
      [expanded]="true"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          My Groups
        </div>
        <div class="w-[60%] flex justify-end items-center flex-row">
          <span class="clickable" (click)="downloadReportClick($event)" *ngIf="loggedInUserRoleKey === roleMap['coach'] && shownDataCount > 0">
            Download Attendance Report
          </span>
          <app-primary-button
            *ngIf="!isDrilldown"
            class="lg:w-[20%] xs:w-[50%] sm:w-[50%] md:w-[35%]"
            type="small"
            (handleClick)="onAddGroup()"
            [isDisabled]="loggedInUserProfileStatus === 2 &&
            loggedInUserRoleKey === roleMap.coach"
          >
            Add Group
          </app-primary-button>
        </div>
      </mat-expansion-panel-header>
      <app-coach-groups-list-table></app-coach-groups-list-table>
    </mat-expansion-panel>
  </div>
</div>
